import '@webcomponents/custom-elements';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from 'root';
import data from '@emoji-mart/data';
import { init } from 'emoji-mart';

import 'ht-spinner';
import * as serviceWorkerRegistration from './service-worker-registration';
import { ErrorBoundary } from './error-boundary';

import './index.scss';

import application from 'application';
import performanceTracker from 'performance-tracker';
import './error-logging';
import './chunk-recovery';

init({ data });

const rootProperties = {
  authenticated: application.isAuthenticated()
};

function MainRenderer() {

  return <React.StrictMode>
    <ErrorBoundary>
      <Root {...rootProperties} />
    </ErrorBoundary>
  </React.StrictMode>;

}

serviceWorkerRegistration.register({
  onUpdate: registration => {
    // eslint-disable-next-line no-console
    console.log('New content is available; please refresh.');
  },
  onSuccess: registration => {
    // eslint-disable-next-line no-console
    console.log('Content is cached for offline use.');
  },
});

function startApp() {
  performanceTracker.reportLoad();
  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);
  root.render(<MainRenderer />);
}

startApp();